// GridComponent.js
import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Passives from './panels/passives';
import Spells from './panels/Spells';
import Inventory from './panels/Inventory'
import Groupe from './panels/Groupe'
import Tarot from './panels/Tarot'

const Onglets = ({ passives, spells, items, personnage,idPerso,token }) => {
  return (
    <Tabs>
      <TabList>
        <Tab>Passifs</Tab>
        <Tab>Sorts</Tab>
        <Tab>Inventaire</Tab>
        {personnage.groupes !== null && (
          <Tab>Groupe</Tab>    
        )}
        {personnage.prenom == "Kass" && (
          <Tab>Tarot</Tab>  
      )}
      </TabList>

      <TabPanel>
        <Passives passives={passives} idPerso={idPerso}  token={token}></Passives>
      </TabPanel>
      <TabPanel>
        <Spells spells={spells} idPerso={idPerso}  token={token}></Spells>
      </TabPanel>
      <TabPanel>
        <Inventory idPerso={idPerso}  token={token}></Inventory>
      </TabPanel>
      {
        personnage !== null && (
          <TabPanel>
            <Groupe personnage={personnage} idPerso={idPerso}  token={token}></Groupe>
          </TabPanel> )
      }
      {personnage.prenom == "Kass" && (
        <TabPanel>
          <Tarot token={token}></Tarot>
        </TabPanel>  
      )}
    </Tabs>
  );
};


export default Onglets;
